import React from "react";
import { Icon } from "@culturehq/components";

import { Trans } from "app/utils";

import StaticWidgetToggle from "./StaticWidgetToggle";

const LeaderboardWidget = ({ disabled }) => (
  <tr data-id="leaderboard">
    {!disabled && (
      <td className="sortable__drag-handler" />
    )}
    <td>
      <Icon icon="ios-list-outline" />
    </td>
    <td />
    <td>
      <Trans>Top Community Scores</Trans>
    </td>
    <td className="max-width-300">
      <Trans>Show top Community Scores in your organization.</Trans>
    </td>
    <td className="max-width-300">
      <Trans>For You</Trans>
    </td>
    <td>
      <StaticWidgetToggle name="leaderboard" disabled={disabled} />
    </td>
  </tr>
);

export default LeaderboardWidget;
